import React, { useEffect } from "react";
import "./our.css";

const HeaderOur = () => {
   useEffect(() => {
                const faders = document.querySelectorAll('.fade-in');
              
                const appearOptions = {
                  threshold: 0.1,
                  rootMargin: "0px 0px -50px 0px"
                };
              
                const appearOnScroll = new IntersectionObserver((entries, observer) => {
                  entries.forEach(entry => {
                    if (!entry.isIntersecting) return;
                    entry.target.classList.add('show');
                    observer.unobserve(entry.target);
                  });
                }, appearOptions);
              
                faders.forEach((fader, index) => {
                  const el = fader as HTMLElement; // ✅ típus assertion
                  el.style.transitionDelay = `${index * 0.2}s`;
                  appearOnScroll.observe(el);
                });
              
              }, []);
  return (
  <div className="our-header">
  <div className="our-content">
    <h1 className="our-h1 fade-in">Our Expertise</h1>
    <p className="app-p fade-in">
      Approaching the understanding and management of human risk and safety in the complex modern landscape.
      As economic and geopolitical uncertainty has increased together with rapid technological advancement,
      the risk and threat associated with human behaviour has also increased significantly.
    </p>
  </div>
</div>

  
  );
};

export default HeaderOur;
